import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { NavLink, useHistory, useRouteMatch } from "react-router-dom";
import { tokenKeyName, localStorageVar } from "../../config";
import jwtDecode from "jwt-decode";
import DiligentLogo from "../../assets/logo_head.png";
import {
  // hasAccessToDedicated,
  isClient,
  isLoggedIn,
  isMainClientAccount,
} from "../../services/accountService";
import { accesses, divisionAccesses } from "../../constants";
import { pages } from "../../constants";
// import { AiFillNotification } from "react-icons/ai";
import { SwitchUser } from "./SwitchUser";
import { determineHasAccessToCDKFeatures } from "../../helpers/utilities";
import { useLocation } from "react-router-dom";

import { getClientDefaultLandingPage } from "../../services/accountService";
import { getLandingPageUrl } from "../ClientProfile/LandingPageSelector";
import { NotificationsDropdown } from "./NotificationsDropdown";
import { RestrictedContent } from "./RestrictedContent";
import ContactSupportPageNav from "../ContactSupportPage";
import { CustomerSurvey } from "../Survey/CustomerSurvey";

const disabledLinkHandler = (e) => {
  e.preventDefault();
};

const ClientNavbar = ({
  onLogoutClick,
  loggedIn,
  userName,
  decodedClientInfo,
  setLoading,
  linkedAccounts,
  setLinkedAccounts,
  cdkSubscriptionStatus,
}) => {
  const location = useLocation();
  const { data: defaultLandingPage } = useQuery({
    queryKey: ["default-landing-page"],
    queryFn: getClientDefaultLandingPage,
    enabled: isLoggedIn() && isClient(),
    refetchOnWindowFocus: false,
    retry: 2,
  });

  return (
    <Navbar
      className="portal-navbar"
      collapseOnSelect
      expand="lg"
      bg="dark"
      variant="dark"
      sticky="top"
    >
      <NavLink
        className="navbar-brand"
        to={
          isLoggedIn()
            ? getLandingPageUrl(defaultLandingPage?.data?.homePage)
            : pages.loginPage.url
        }
      >
        <img
          // src={`${url}images/logo_head.png`} // not sure why ismael was using this? - breaks when i hadd homepage path to package.json
          // src={"./images/logo_head.png"} // breaks on pages where path is different from the base
          // src={"/images/logo_head.png"} //starting with slash should make it relative to project root and work in all cases but not working? - maybe because of the react-router base path?
          // another possible solution? might conflict with our react router base path? https://stackoverflow.com/a/49491181/12156650
          // src={"/images/logo_head.png"}
          src={DiligentLogo} //imported from within src directory, only solution that is working for me currently. Not sure whether this is a bad practice or not, for now we only have 1 image. Want to figure out a solution to use public/images as src
          alt="Diligent Emblem"
          width="50px"
        />{" "}
        Diligent Client Portal™
      </NavLink>
      {!isLoggedIn() && (
        <>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto">
              {location.pathname?.toLowerCase() === pages.loginPage.url ? (
                <Nav.Link
                  as={NavLink}
                  key="track-barcode"
                  to={pages.trackBarcode.url}
                >
                  Track Barcode
                </Nav.Link>
              ) : (
                <Nav.Link as={NavLink} key="login" to={pages.loginPage.url}>
                  Login
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </>
      )}

      {isLoggedIn() && (
        <React.Fragment>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto">
              <RestrictedContent>
                <NavLink className="nav-link" to="/dashboard">
                  Dashboard
                </NavLink>
              </RestrictedContent>
              {/* collapsible-nav-dropdown1 is the one wrapping the client profile and logout buttons */}

              <NavDropdown title="Orders" id="collasible-nav-dropdown2">
                <NavDropdown.Item
                  eventKey="orderHistory"
                  as={NavLink}
                  to={pages.orderHistory.url}
                >
                  Order History
                </NavDropdown.Item>

                {/* <NavDropdown.Item
                  eventKey="orderHistoryPagination"
                  as={NavLink}
                  to="/order-history-pagination"
                >
                  Order History Pagination
                </NavDropdown.Item> */}

                <RestrictedContent>
                  {(decodedClientInfo[accesses.IsMainAccount] ||
                    decodedClientInfo[accesses.Deltrans]) && (
                    <>
                      <NavDropdown.Item
                        eventKey="newOrder"
                        as={NavLink}
                        to="/post-order"
                      >
                        New Order
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        eventKey="newBuyout"
                        as={NavLink}
                        to="/PostNewBuyout"
                      >
                        New Buyout
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        eventKey="returnRequest"
                        as={NavLink}
                        to={pages.returnRequest.url}
                      >
                        Return Requests
                      </NavDropdown.Item>
                    </>
                  )}
                </RestrictedContent>
              </NavDropdown>

              <RestrictedContent>
                {(decodedClientInfo[accesses.IsMainAccount] ||
                  decodedClientInfo[accesses.Concerns] ||
                  decodedClientInfo[accesses.Claims]) && (
                  <NavDropdown
                    title="Customer Service"
                    id="collasible-nav-dropdown4"
                  >
                    {(decodedClientInfo[accesses.IsMainAccount] ||
                      decodedClientInfo[accesses.Concerns]) && (
                      <NavDropdown.Item
                        eventKey="deliveryConcerns"
                        as="span"
                        bsPrefix="react-bs-remover"
                      >
                        <NavLink
                          className="dropdown-item"
                          to="/delivery-concern"
                        >
                          Delivery Concerns
                        </NavLink>
                      </NavDropdown.Item>
                    )}
                    {(decodedClientInfo[accesses.IsMainAccount] ||
                      decodedClientInfo[accesses.Claims]) && (
                      <NavDropdown.Item
                        eventKey="claims"
                        as="span"
                        bsPrefix="react-bs-remover"
                      >
                        <NavLink className="dropdown-item" to="/claim">
                          Claims
                        </NavLink>
                      </NavDropdown.Item>
                    )}
                  </NavDropdown>
                )}
              </RestrictedContent>
              <RestrictedContent>
                {(decodedClientInfo[accesses.IsMainAccount] ||
                  decodedClientInfo[accesses.Invoice]) && (
                  // <OverlayTrigger
                  //   flip
                  //   overlay={<TooltipStandard>Under Maintenance!</TooltipStandard>}
                  // >
                  <NavDropdown
                    title="Billing"
                    id="collasible-nav-dropdown5"
                    // disabled
                  >
                    <NavDropdown.Item
                      eventKey="invoices"
                      as="span"
                      bsPrefix="react-bs-remover"
                    >
                      <NavLink className="dropdown-item" to="/invoices">
                        Invoices
                      </NavLink>
                    </NavDropdown.Item>
                  </NavDropdown>
                  // </OverlayTrigger>
                )}
              </RestrictedContent>
              {/* <Nav.Link
                as={NavLink}
                className="nav-link"
                activeClassName="active"
                to="/invoices"
                eventKey="invoices"
              >
                Invoices
              </Nav.Link> */}
              <RestrictedContent>
                <NavDropdown title="Reports" id="collapsible-nav-dropdown6">
                  <NavDropdown.Item
                    eventKey="shipmentAnalysisReport"
                    as="span"
                    bsPrefix="react-bs-remover"
                  >
                    <NavLink
                      className="dropdown-item"
                      to="/ShipmentAnalysisReport"
                    >
                      Shipment Analysis Reports
                    </NavLink>
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    eventKey="discrepancyReports"
                    as="span"
                    bsPrefix="react-bs-remover"
                  >
                    <NavLink className="dropdown-item" to="/DiscrepancyReports">
                      Discrepancy Reports
                    </NavLink>
                  </NavDropdown.Item>
                  {/* <NavDropdown.Item
                    eventKey="reportGraphsTest"
                    as="span"
                    bsPrefix="react-bs-remover"
                  >
                    <NavLink className="dropdown-item" to="/ReportGraphsTest">
                      Report Graphs Test
                    </NavLink>
                  </NavDropdown.Item> */}
                  {/* <NavDropdown.Item
                    eventKey="codReport"
                    as="span"
                    bsPrefix="react-bs-remover"
                  >
                    <NavLink className="dropdown-item" to={pages.CODReport.url}>
                      COD Report
                    </NavLink>
                  </NavDropdown.Item> */}
                </NavDropdown>
              </RestrictedContent>
              <NavDropdown title="Integrations" id="collasible-nav-dropdown3">
                {determineHasAccessToCDKFeatures(cdkSubscriptionStatus) ? (
                  decodedClientInfo.IsCdkClient ? (
                    <>
                      <NavDropdown.Item
                        eventKey="importCDKOrder"
                        as="span"
                        bsPrefix="react-bs-remover"
                      >
                        <RestrictedContent>
                          <NavLink
                            className={
                              "dropdown-item"
                              // +
                              // (decodedClientInfo.IsCdkClient ? "" : " disabled")
                            }
                            to={pages.cdkOrderImport.url}
                          >
                            CDK Order Import
                          </NavLink>
                        </RestrictedContent>
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        eventKey="cdkSettings"
                        as="span"
                        bsPrefix="react-bs-remover"
                      >
                        <NavLink
                          className={
                            "dropdown-item"
                            // +
                            // (decodedClientInfo.IsCdkClient ? "" : " disabled")
                          }
                          to="/cdk-settings"
                        >
                          CDK Settings
                        </NavLink>
                      </NavDropdown.Item>
                    </>
                  ) : (
                    <NavDropdown.Item
                      eventKey="importCDKOrder"
                      as="span"
                      bsPrefix="react-bs-remover"
                    >
                      <div className="px-2 font-small text-note">
                        Please sign in again to access CDK features.
                      </div>
                    </NavDropdown.Item>
                  )
                ) : (
                  <NavDropdown.Item
                    eventKey="cdkSubscription"
                    as="span"
                    bsPrefix="react-bs-remover"
                  >
                    <NavLink
                      className="dropdown-item"
                      to={pages.cdkIntroduction.url}
                    >
                      CDK Subscription
                    </NavLink>
                  </NavDropdown.Item>
                )}
              </NavDropdown>
              <RestrictedContent
                allowedDivisionAccesses={[divisionAccesses.dedicated]}
              >
                <NavLink className="nav-link" to="/dedicated-dispatch">
                  Dedicated Dispatch
                </NavLink>
              </RestrictedContent>
            </Nav>
            {/* below nav with style was WIP for adding notification medallion + menu */}
            {/* <Nav style={{ display: "flex", alignItems: "center", gap: "8px" }}>*/}
            <Nav>
              {/* <ContactSupportPageNav /> */}

              <RestrictedContent>
                <NotificationsDropdown />
              </RestrictedContent>
              <NavDropdown
                onClick={() => {}}
                title={
                  isMainClientAccount(decodedClientInfo)
                    ? `Hello ${userName}`
                    : `Logged in as ${decodedClientInfo.given_name} (${decodedClientInfo.nameid})`
                }
                id="collasible-nav-dropdown"
                className="navbar-profile-dropdown-align"
              >
                <NavDropdown.Item
                  eventKey="releaseNoteKey"
                  as="span"
                  bsPrefix="react-bs-remover"
                >
                  {/* <NavLink className="dropdown-item" to="/about-page">
                    About
                  </NavLink> */}
                </NavDropdown.Item>
                <NavDropdown.Item
                  eventKey="viewProfile"
                  as="span"
                  bsPrefix="react-bs-remover"
                >
                  <NavLink className="dropdown-item" to="/view-profile">
                    View Profile
                  </NavLink>
                </NavDropdown.Item>

                <RestrictedContent>
                  <NavDropdown.Item
                    eventKey="settings"
                    as="span"
                    bsPrefix="react-bs-remover"
                  >
                    <NavLink className="dropdown-item" to="/settings">
                      Settings
                    </NavLink>
                  </NavDropdown.Item>
                </RestrictedContent>

                <NavDropdown.Item
                  eventKey="help"
                  as="span"
                  bsPrefix="react-bs-remover"
                >
                  <NavLink
                    className="dropdown-item"
                    // target="_blank"
                    // to={constantsJS.pdfLinks.usersGuide}
                    to="/help"
                    rel="noopener noreferrer"
                  >
                    Help
                  </NavLink>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <div
                  style={{
                    padding: "0.25rem 1.5rem",
                  }}
                >
                  <button onClick={onLogoutClick} className="btn btn-danger ">
                    Logout
                  </button>
                </div>
              </NavDropdown>
              <SwitchUser
                setLoading={setLoading}
                decodedClientInfo={decodedClientInfo}
                linkedAccounts={linkedAccounts}
                setLinkedAccounts={setLinkedAccounts}
              />
            </Nav>
          </Navbar.Collapse>
        </React.Fragment>
      )}
    </Navbar>
  );
};

const CustomerNavbar = ({ onLogoutClick, loggedIn, userName, setLoading }) => {
  return (
    <Navbar
      className="portal-navbar"
      collapseOnSelect
      expand="lg"
      bg="dark"
      variant="dark"
      sticky="top"
    >
      <NavLink className="navbar-brand" to={pages.orderHistory.url}>
        <img
          src={DiligentLogo} //imported from within src directory, only solution that is working for me currently. Not sure whether this is a bad practice or not, for now we only have 1 image. Want to figure out a solution to use public/images as src
          alt="Diligent Emblem"
          width="50px"
        />{" "}
        Customer Portal
      </NavLink>
      {isLoggedIn() && (
        <React.Fragment>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto">
              <NavLink className="nav-link" to="/order-history">
                Order History
              </NavLink>

              <NavLink className="nav-link" to="/manual-return">
                Manual Return
              </NavLink>
            </Nav>
            <Nav>
              {/* Customer Survey March, June, Sept, Dec */}
              {/* Client Survey April, July, October, Jan */}
              <CustomerSurvey setLoading={setLoading} />
              <NavDropdown
                title={`Hello ${userName}`}
                id="collasible-nav-dropdown"
                className="navbar-profile-dropdown-align"
              >
                <NavDropdown.Item
                  eventKey="help"
                  as="span"
                  bsPrefix="react-bs-remover"
                >
                  <NavLink
                    className="dropdown-item"
                    // target="_blank"
                    // to={constantsJS.pdfLinks.usersGuide}
                    to="/help"
                    rel="noopener noreferrer"
                  >
                    Help
                  </NavLink>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <div
                  style={{
                    padding: "0.25rem 1.5rem",
                  }}
                >
                  <button
                    onClick={onLogoutClick}
                    className="btn btn-danger"
                    style={{ width: "100%" }}
                  >
                    Logout
                  </button>
                </div>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </React.Fragment>
      )}
    </Navbar>
  );
};

//has access check
const ClientPortalNavbar = ({
  onLogoutClick,
  lastLoginUpdate,
  decodedClientInfo,
  setLoading,
  linkedAccounts,
  setLinkedAccounts,
  cdkSubscriptionStatus,
}) => {
  const { url } = useRouteMatch();

  const [userName, setUserName] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const history = useHistory();

  const token = localStorage.getItem(tokenKeyName); // getting the token here and passing it as a dependency for our loggedIn useEffect ensures whenever the token is changed/deleted etc loggedIn and userName will update and refresh the navbar to display those changes.
  //this is good for refreshing the navbar when people switch accounts and also fixes the issue where they were seeing Customer Portal and their username after being signed out. As loggedIn was still true in state, but isClient returned false as there is no token and therefore no isclient field to begin with.

  useEffect(() => {
    // console.log("running logged in logic again");
    try {
      // console.log(lastLoginUpdate);
      //get user token

      const decodedClientToken = jwtDecode(token);

      // console.log(decodedClientUser);
      setUserName(localStorage.getItem(localStorageVar.displayNameKey));
      setLoggedIn(isLoggedIn());
    } catch (ex) {
      setUserName("");
      setLoggedIn(false);
    }
  }, [lastLoginUpdate, history, token]);
  return !isLoggedIn() ? ( //if they're not logged in, default them to the clientnavbar because that's the default, although as of right now both handle only showing nav buttons if they are logged in.
    <ClientNavbar
      key="signed-out-navbar"
      onLogoutClick={onLogoutClick}
      loggedIn={loggedIn}
      userName={userName}
      decodedClientInfo={decodedClientInfo}
      setLoading={setLoading}
      //this is the logged out display, most likely do not want to add new props
    />
  ) : isClient() ? (
    <ClientNavbar
      key="signed-in-navbar"
      onLogoutClick={onLogoutClick}
      loggedIn={loggedIn}
      userName={userName}
      decodedClientInfo={decodedClientInfo}
      setLoading={setLoading}
      linkedAccounts={linkedAccounts}
      setLinkedAccounts={setLinkedAccounts}
      cdkSubscriptionStatus={cdkSubscriptionStatus}
    />
  ) : (
    <CustomerNavbar
      onLogoutClick={onLogoutClick}
      setLoading={setLoading}
      loggedIn={loggedIn}
      userName={userName}
    />
  );
};

export default ClientPortalNavbar;
